import { useVideoStream } from '../lib/useMedia.ts';

/**
 * Unscharfe Kopie einer Kamera hinter ihrem eigenen Bild -- fuellt im
 * Splitscreen bei „Ganz zeigen" den Rand der Haelfte, wie im Fernsehen bei
 * Hochkant-Videos. So bleibt nichts abgeschnitten und trotzdem nichts
 * schwarz, und die Bauchbinde liegt links wie rechts auf Bild.
 *
 * Eine eigene Komponente, damit der Stream beim Einhaengen haengt: das
 * Element kommt erst mit dem Umschalten auf „Ganz zeigen" dazu, der Stream
 * selbst aendert sich dabei nicht. Es ist dieselbe Spur wie im Bild davor --
 * dekodiert wird sie einmal, gezeichnet zweimal.
 */
export function SplitFill({
  stream,
  className,
  blank,
}: {
  stream: MediaStream | null | undefined;
  /** `split-fill` hinter dem Hauptbild, `pip__fill` im Fenster der zweiten Kamera. */
  className: string;
  /** Kamera abgeblendet -- dann auch keine Kopie davon. */
  blank?: boolean;
}) {
  const ref = useVideoStream(stream);
  return (
    <div className={`${className}${blank ? ' is-blank' : ''}`} aria-hidden>
      <video ref={ref} autoPlay playsInline muted />
    </div>
  );
}
